import { Box, Button, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../global/config/store'
import { toast } from 'react-toastify'
import { ApiAnnualReport, ApiCalenderReport, ApiClientAnnualReport, ApiFinancialReport } from '../../apiService/Core/Apicall'
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice'
import storage from '../../utils/storage'

function ReportCenter() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [selectedReportType, setselectedReportType] = useState<string>('calender')
    const [reportyear, setreportyear] = useState<any>(dayjs(selectedMonth))
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)


    const viewClientOldAnnualReport = async () => {
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&year=${reportyear.year()}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;

        try {
            const response = selectedReportType === 'financial' ? await ApiFinancialReport(data) : await ApiCalenderReport(data); // responseType: 'blob'

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            console.log("Url pdf", url)
            setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            console.log(error)
        }
    };
    const viewVenueAnnualReport = async () => {
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&year=${reportyear.year()}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}${selectedReportType === 'financial' ? `&isFinancialReport=true` : ""}`;

        try {
            const response = await ApiAnnualReport(data); // responseType: 'blob'

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            console.log("Url pdf", url)
            setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            console.log(error)
        }
    };
    const viewClientNewAnnualReport = async () => {
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&year=${reportyear.year()}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}${selectedReportType === 'financial' ? `&isFinancialReport=true` : ""}`;

        try {
            const response = await ApiClientAnnualReport(data); // responseType: 'blob'

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            console.log("Url pdf", url)
            setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            console.log(error)
        }
    };
    const downloadClientOldAnnualReport = async () => {
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&year=${reportyear.year()}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;

        try {
            const response = selectedReportType === 'financial' ? await ApiFinancialReport(data) : await ApiCalenderReport(data); // responseType: 'blob'

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const formattedType = selectedReportType.charAt(0).toUpperCase() + selectedReportType.slice(1);
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${formattedType}_Report_${storage.getItem('clientEntityName') ? storage.getItem('clientEntityName') : ''}_${reportyear.year()}.pdf`; // custom file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            console.log(error)
        }
    };
    const downloadVenueAnnualReport = async () => {
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&year=${reportyear.year()}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}${selectedReportType === 'financial' ? `&isFinancialReport=true` : ""}`;

        try {
            const response = await ApiAnnualReport(data);

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const formattedType = selectedReportType.charAt(0).toUpperCase() + selectedReportType.slice(1);
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${formattedType}_Report_${storage.getItem('clientEntityName') ? storage.getItem('clientEntityName') : ''}_${reportyear.year()}.pdf`; // custom file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            console.log(error)
        }
    };
    const handledownloadClientNewAnnualReport = async () => {
        const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}&year=${reportyear.year()}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}${selectedReportType === 'financial' ? `&isFinancialReport=true` : ""}`;

        try {
            const response = await ApiClientAnnualReport(data);

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const formattedType = selectedReportType.charAt(0).toUpperCase() + selectedReportType.slice(1);
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${formattedType}_Report_${storage.getItem('clientEntityName') ? storage.getItem('clientEntityName') : ''}_${reportyear.year()}.pdf`; // custom file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            console.log(error)
        }
    };

    useEffect(() => {
        const timeout = setTimeout(() => {
        //    storage.getItem('userRole') === 'venueadmin' ? viewVenueAnnualReport() : viewClientNewAnnualReport();
           storage.getItem('userRole') === 'venueadmin' ? viewVenueAnnualReport() : ( storage.getItem('ClientGroupName') === "MM" || storage.getItem('ClientGroupName') === "EXTENDED" || storage.getItem('ClientGroupName') === "JBHIFI" || storage.getItem('ClientGroupName') === "BLOOMS") ? viewClientNewAnnualReport() : viewClientOldAnnualReport();
        }, 300);

        return () => clearTimeout(timeout);
    //    storage.getItem('userRole') === 'clientadmin' ? viewClientOldAnnualReport() : viewVenueAnnualReport()
    }, [reportyear, selectedReportType, clientEntity, isGroupScore])

    useEffect(() => {
        return () => {
            if (pdfUrl) URL.revokeObjectURL(pdfUrl);
        };
    }, [pdfUrl]);

    useEffect(() => {
        setreportyear(dayjs(selectedMonth).startOf('month'))
    }, [selectedMonth])

    return (
        <Box className='mt-3'>
            <Box className='d-flex justify-content-end align-items-center mb-3 mt-2' gap={{ lg: 1 }}>
                {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") === "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
                    <Box>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isGroupScore}
                                    onChange={(e) => setisGroupScore(e.target.checked)}
                                />
                            }
                            label={"Whole Group"}
                        />
                    </Box>)}
                <FormControl sx={{ width: 'fit-content', minWidth: '10px' }}>
                    <InputLabel id="demo-simple-select-label" sx={{ minWidth: '300px' }}>Report Type: &nbsp;</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedReportType}
                        label='Report Type'
                        onChange={(e: any) => { setselectedReportType(e.target.value) }}
                    >
                        <MenuItem value='financial'>
                            Financial Report
                        </MenuItem>
                        <MenuItem value='calender'>
                            Calender Report
                        </MenuItem>
                    </Select>
                </FormControl>
                <Box width={{ xs: '75%', md: 'fit-content' }} maxWidth='100px' className='d-flex align-items-center justify-content-start'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker value={reportyear} className='month-select3'
                            views={['year']}
                            format="YYYY"
                            label='Year: &nbsp;'
                            onChange={(e: any) => {
                                const isoString = e?.startOf('month').toISOString();
                                dispatch(setSelectedMonth(isoString));
                            }}

                            maxDate={dayjs().add(5, 'year')}
                            slots={{
                                openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                            }}
                        />
                    </LocalizationProvider>
                </Box>
            </Box>
            <Box className='d-flex justify-content-end my-1 mb-2'>
                <Button className='button-primary' onClick={() => {storage.getItem('userRole') === 'venueadmin' ? downloadVenueAnnualReport() : ( storage.getItem('ClientGroupName') === "MM" || storage.getItem('ClientGroupName') === "JBHIFI" || storage.getItem('ClientGroupName') === "EXTENDED" || storage.getItem('ClientGroupName') === "BLOOMS") ? handledownloadClientNewAnnualReport() : downloadClientOldAnnualReport()}}>Download</Button>
            </Box>

            {pdfUrl && (
                // <Document
                //     file={`/proxy-pdf?url=https://external.com/sample.pdf`}
                //     onLoadError={(error) => console.error('PDF load error:', error)}
                //     onSourceError={(error) => console.error('Source error:', error)}
                // >
                //     <Page pageNumber={1} />
                // </Document>
                <iframe
                    src={pdfUrl + "#toolbar=0"}
                    title="Monthly Report PDF"
                    width="100%"
                    height="700px"
                    style={{ border: 'none' }}
                />
            )}

        </Box>
    )
}

export default ReportCenter
